import React from 'react';
import { Card } from '../components/ui/Card';
import { Badge } from '../components/ui/Badge';
import SafeIcon from '../components/common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { useApp } from '../context/AppContext';

export const Procurement = () => {
    const { data } = useApp();
    const { contractors } = data;

    return (
        <div className="space-y-6">
            <div className="flex justify-between items-center">
                <div>
                    <h1 className="text-2xl font-bold text-slate-900">Procurement Oversight</h1>
                    <p className="text-slate-500">Contract lifecycle and contractor performance tracking.</p>
                </div>
                <div className="flex gap-3">
                    <button className="px-4 py-2 bg-white border border-slate-300 rounded-lg text-sm font-medium text-slate-700 hover:bg-slate-50">
                        Debarment Register
                    </button>
                    <button className="px-4 py-2 bg-grn-navy text-white rounded-lg text-sm font-medium hover:bg-blue-900">
                        View Annual Plans
                    </button>
                </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                 <Card title="Contractor Watch List" className="h-full">
                    <div className="space-y-4">
                        {contractors.map((contractor, idx) => (
                            <div key={idx} className="flex items-center justify-between p-3 rounded-lg border border-slate-100 hover:border-slate-300 hover:bg-slate-50 transition-all">
                                <div>
                                    <h4 className="font-bold text-slate-800 text-sm">{contractor.name}</h4>
                                    <p className="text-xs text-slate-500">{contractor.contracts} active contracts • {(contractor.value / 1e6).toFixed(1)}M NAD</p>
                                </div>
                                <div className="text-right">
                                    <div className={`text-lg font-bold ${contractor.score < 60 ? 'text-red-600' : 'text-green-600'}`}>
                                        {contractor.score}
                                    </div>
                                    <Badge status={contractor.status} size="sm" />
                                </div>
                            </div>
                        ))}
                    </div>
                 </Card>

                 <Card title="Procurement Lifecycle Compliance" className="h-full">
                    <div className="relative pl-6 border-l-2 border-slate-200 space-y-8 my-4">
                        <div className="relative">
                            <span className="absolute -left-[31px] top-1 h-4 w-4 rounded-full bg-green-500 border-2 border-white"></span>
                            <h4 className="font-bold text-slate-800 text-sm">Annual Procurement Plans</h4>
                            <p className="text-xs text-slate-500 mt-1">28% Submission Rate (Critical Low)</p>
                            <div className="w-full bg-slate-100 h-1.5 rounded-full mt-2">
                                <div className="bg-red-500 w-[28%] h-1.5 rounded-full"></div>
                            </div>
                        </div>
                        <div className="relative">
                            <span className="absolute -left-[31px] top-1 h-4 w-4 rounded-full bg-green-500 border-2 border-white"></span>
                            <h4 className="font-bold text-slate-800 text-sm">Funds Certification</h4>
                            <p className="text-xs text-slate-500 mt-1">92% Compliance</p>
                            <div className="w-full bg-slate-100 h-1.5 rounded-full mt-2">
                                <div className="bg-green-500 w-[92%] h-1.5 rounded-full"></div>
                            </div>
                        </div>
                        <div className="relative">
                            <span className="absolute -left-[31px] top-1 h-4 w-4 rounded-full bg-amber-500 border-2 border-white"></span>
                            <h4 className="font-bold text-slate-800 text-sm">Award Publication (7 Days)</h4>
                            <p className="text-xs text-slate-500 mt-1">64% Compliance</p>
                            <div className="w-full bg-slate-100 h-1.5 rounded-full mt-2">
                                <div className="bg-amber-500 w-[64%] h-1.5 rounded-full"></div>
                            </div>
                        </div>
                    </div>
                 </Card>
            </div>
        </div>
    );
};